import { useAuth0 } from 'app/Auth'
import axios from 'axios'
import { useMutation } from 'react-query'

interface AssignPrefCardToSurgeryParams {
  surgery_id: string
  id: string
}

interface AssignPrefCardToSurgeryResponse {
  message: string
}

export const useAssignPrefCardToSurgery = () => {
  const { getAccessToken } = useAuth0()
  const REPORTS_URL = process.env.REACT_APP_REPORTS_URL

  const mutation = useMutation<
    AssignPrefCardToSurgeryResponse,
    Error,
    AssignPrefCardToSurgeryParams
  >(async (data: AssignPrefCardToSurgeryParams) => {
    const token = await getAccessToken()
    try {
      const response = await axios.post(
        // `POST /api/v1/preference_cards/{preference_card_id}/assign/{surgery_id}`
        `${REPORTS_URL}api/v1/preference_cards/${data.id}/assign/${data.surgery_id}`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    } catch (error) {
      throw error
    }
  })

  return mutation
}
